export const contentSection = "content";
export const dismissableSection = 'isDismissable';
export const dateRangeSection = 'useDateRange';
export const startSection = 'publishStartDate';
export const endSection = 'publishEndDate';
